import Vue from "vue";
import ppdwTextField from '_C/shared/ppdwTextField.vue';
import ppdwAutocomplete from '_C/shared/ppdwAutocomplete.vue';
import ppdwDateField from '_C/shared/ppdwDateField.vue';
import ppdwAddress from '_C/shared/ppdwAddress.vue';
import ppdwTooltip from '_C/shared/ppdwTooltip.vue';
import ppdwIconTextBtn from '_C/shared/ppdwIconTextBtn.vue';
import ExclamationIcon from '_C/shared/icons/ExclamationIcon.vue';
import LockIcon from '_C/shared/icons/LockIcon.vue';
import PencilIcon from '_C/shared/icons/PencilIcon.vue';
import TrashCanIcon from '_C/shared/icons/TrashCanIcon.vue';
import UpdateIcon from '_C/shared/icons/UpdateIcon.vue';
import UpdateDottedIcon from '_C/shared/icons/UpdateDottedIcon.vue';
import ppdwTooltipHover from '_C/shared/ppdwTooltipHover.vue';
import ppdwYearPicker from '_C/shared/ppdwYearPicker.vue';
import ModificationInput from "_C/shared/ModificationInput.vue";
import CalcCard from '_C/shared/CalcCard/CalcCard.vue';
import CheckIcon from '_C/shared/icons/CheckIcon.vue';

Vue.component('ppdw-text-field', ppdwTextField)
Vue.component('ppdw-autocomplete', ppdwAutocomplete)
Vue.component('ppdw-date-field', ppdwDateField)
Vue.component('ppdw-year-picker', ppdwYearPicker)
Vue.component('ppdw-address', ppdwAddress)
Vue.component('ppdw-tooltip', ppdwTooltip)
Vue.component('ppdw-tooltip-hover', ppdwTooltipHover)
Vue.component('ppdw-icon-text-btn', ppdwIconTextBtn)
Vue.component('modification-input', ModificationInput)

Vue.component('icon-exclamation', ExclamationIcon)
Vue.component('icon-lock', LockIcon)
Vue.component('icon-pencil', PencilIcon)
Vue.component('icon-trash-can', TrashCanIcon)
Vue.component('icon-update', UpdateIcon)
Vue.component('icon-update-dotted', UpdateDottedIcon)
Vue.component('icon-check', CheckIcon)

Vue.component('CalcCard', CalcCard)